const MAX_LENGTH = 200;

export function useUrlSearchTerm(key = "q", opts: { debounceMs?: number } = {}) {
  const route = useRoute();
  const router = useRouter();
  const debounceMs = opts.debounceMs ?? 300;

  function readValue(): string {
    const raw = route.query[key];
    if (typeof raw !== "string") return "";
    const trimmed = raw.trim();
    return trimmed.length > MAX_LENGTH ? "" : trimmed;
  }

  const applied = computed(() => readValue());
  const term = ref(applied.value);

  watch(applied, (v) => {
    if (term.value.trim() !== v) term.value = v;
  });

  let timer: ReturnType<typeof setTimeout> | undefined;
  watch(term, (v) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      const next = v.trim();
      if (next === readValue()) return;
      const query = { ...route.query };
      if (next.length && next.length <= MAX_LENGTH) query[key] = next;
      else delete query[key];
      router.push({ query });
    }, debounceMs);
  });

  onBeforeUnmount(() => clearTimeout(timer));

  const chip = computed<{ label: string } | undefined>(() =>
    applied.value ? { label: applied.value } : undefined
  );

  function clear() {
    term.value = "";
  }

  return { term, applied, chip, clear };
}
